import { render, staticRenderFns } from "./BetslipBetComboA.vue?vue&type=template&id=c6f8044c&scoped=true"
import script from "./BetslipBetComboA.vue?vue&type=script&lang=js"
export * from "./BetslipBetComboA.vue?vue&type=script&lang=js"
import style0 from "./BetslipBetComboA.vue?vue&type=style&index=0&id=c6f8044c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6f8044c",
  null
  
)

export default component.exports